<app-widget-base [title]="title">
  <div class="chart" #chart></div>
  <div #tooltip class="tooltip hidden">
    <div class="tooltip-content">
      <p>
        <span class="name"></span>
        <span class="category"></span>
      </p>
      <p>
        <span class="value"></span>
        <small class="unit"></small>
      </p>
    </div>
  </div>
</app-widget-base>
